import { mergeClassName } from '../../utils/mergeClassName'

type ReactDiv = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>

const Field: React.FC<ReactDiv> = ({
  className,
  children,
  ...props
}) => {
  return (
    <div
      className={mergeClassName(
        'my-4',
        className,
      )}
      {...props}
    >
      { children }
    </div>
  )
}

export default Field
